import { RawIntlProvider } from 'react-intl';
import { ReactNode } from 'react';
import { intl } from 'src/config/intl/intl';

export const AppIntlProvider = ({ children }: { children: ReactNode }) => {
  return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
};
